import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextArea from 'modules/core/components/TextArea'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useRejectRequisition } from 'modules/ats/hooks/requisitions/useRejectRequisition'
import { AtsRequisition } from 'modules/ats/hooks/requisitions/useRequisition'

interface Props {
  requisition: AtsRequisition
  onClose: () => void
}

interface RejectFormValues {
  reason: string
  approverId: number
  id: number
}

export const RejectRequisitionModal = ({ requisition, onClose }: Props) => {
  const { rejectRequisition } = useRejectRequisition()
  const {
    access: { id: accessId },
  } = useCurrentSession()
  const { values, setValues, isSubmitting, errors, setErrors, handleSubmit } =
    useForm<RejectFormValues>({
      defaultValues: {
        id: requisition.id,
        approverId: accessId,
        reason: '',
      },
      onSubmit: async (values) => {
        const result = await rejectRequisition(values)
        const handled = handleResult(result, (errors) => {
          if (errors) {
            setErrors(errors)
          }
        })

        setFlashMessage(handled.success)
        onClose()

        return handled
      },
    })

  const setFlashMessage = (success: boolean) => {
    const type = success ? 'correct' : 'wrong'
    const message = success
      ? i18n.t('ats.jobs_requisitions.actions.reject.rejected')
      : i18n.t('ats.jobs_requisitions.actions.error')

    app.setFlash({
      type: type,
      message: message,
      time: 2000,
    })
  }

  return (
    <Modal
      illustration="add-user"
      title={i18n.t('ats.jobs_requisitions.actions.reject.title')}
      description={i18n.t('ats.jobs_requisitions.actions.reject.description')}
      onSubmit={() => handleSubmit()}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={isSubmitting} submit>
            {i18n.t('ats.jobs_requisitions.actions.reject.reject_button')}
          </Button>
        </>
      }
    >
      <TextArea
        label={i18n.t('ats.jobs_requisitions.actions.reject.reason')}
        placeholder={i18n.t('ats.jobs_requisitions.actions.reject.reason_placeholder')}
        value={values.reason}
        onChange={(reason) => setValues({ ...values, reason })}
        error={errors.reason}
      />
    </Modal>
  )
}
